<template>
    <div class="max-w-content">
        <span title="Закрыть" class="js-hide-leaving-component with-text" @click="$emit('close')" >
            <icon-base><icon-arrow width="16" height="16" viewBox="0 0 16 16"></icon-arrow></icon-base>
            Вернуться к списку</span>
    <div class="profile-box">
        <div class="profile">
            <p class="name">{{fullName}}</p>
            <p v-if="!candidate" class="position">{{employee.position}}</p>
            <p v-if="!candidate" class="sub-position">{{subPositions}}</p>
            <select-field v-show="candidate" :class="'status-select'" :id="'emp-'+employee.id" :options="options" :value="employee.status" @input="statusInput($event)"></select-field>
            <div class="profile-tabs tabs-box">
                <ul class="tabs-nav">
                    <li v-for="(tab, index) in tabs" :key="index" :class="tab.id === currentTab ? 'active' : ''" @click="currentTab=tab.id"><a href @click.prevent>{{tab.title}}</a></li>
                </ul>
                <div class="tabs-content">
                    <component-switcher>
                        <component :is="tabs[currentTab].component" :employee="employee"></component>
                    </component-switcher>
                </div>
            </div>
        </div>
    </div>
    </div>

</template>

<script>
    import {mapActions} from 'vuex'
    import SelectField from "../common/fields/SelectField";

    import TabsComponent from "../common/Tabs";
    import CurrentEmployeeInfo from "./CurrentEmployeeInfo";
    import CurrentEmployeeHistory from "./CurrentEmployeeHistory";
    import CurrentEmployeeStudy from "./CurrentEmployeeStudy";
    import CurrentEmployeeNotes from "./CurrentEmployeeNotes";
    import InputField from "../common/fields/InputField";
    import IconBase from "../common/IconBase";
    import IconArrow from "../common/icons/IconArrowClose";
    import ComponentSwitcher from "../common/ComponentSwitcher";
    export default {
        name: 'current-employee-component',
        components: {
            ComponentSwitcher,
            IconBase,
            IconArrow,
            InputField,
            CurrentEmployeeNotes,
            CurrentEmployeeStudy, CurrentEmployeeHistory, CurrentEmployeeInfo, TabsComponent, SelectField
        },
        props: {
            employee: Object,
            candidate: Boolean
        },
        data() {
            return {
                currentTab: 0,
                options: {
                    values: ["Ожидает проверки","Заполнил анкету","Создал пароль"],
                },
                tabs: [
                    {
                        id: 0,
                        title: "Информация",
                        component: CurrentEmployeeInfo
                    },
                    {
                        id: 1,
                        title: "Обучение",
                        component: CurrentEmployeeStudy
                    },
                    {
                        id: 2,
                        title: "Заметки",
                        component: CurrentEmployeeNotes
                    },
                    {
                        id: 3,
                        title: "История",
                        component: CurrentEmployeeHistory
                    }
                ]
            }
        },
        computed: {
            fullName() {
                return this.employee.name + ' ' + this.employee.sername + ' ' + this.employee.patronymic
            },
            subPositions() {
                let text = '';
                if (this.employee.subPositions) {
                    this.employee.subPositions.forEach((item, index) => {
                        text += index ? ', ' : '';
                        text += item;
                    });
                }
                return text
            }
        },
        methods: {
            ...mapActions('people',[
                'saveEmployeeStatus'
            ]),
            tabClick(index) {
                this.currentTab = index
            },
            statusInput(e) {
                if (!this.$_.isEmpty(this.employee)) {
                    this.saveEmployeeStatus(e)
                }
            }

        },
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

</style>
